import type { ShipmentScaleTicket } from './shipments-shared.dto.js';

export interface ListScaleTicketsRequest {
  companyId: string;
  shipmentId: string;
  stationId: string;
}

export const shipmentFollowUpComparisonStatusValues = [
  'awaiting_processor_ticket',
  'received_at_or_above_expected_sent',
  'received_within_proxy_range',
  'received_below_proxy_threshold',
] as const;

export type ShipmentFollowUpComparisonStatus =
  (typeof shipmentFollowUpComparisonStatusValues)[number];

export interface ListScaleTicketsResponse {
  scaleTickets: ShipmentScaleTicket[];
  expectedSentLb: number;
  minimumAcceptableReceivedLb: number;
  measuredReceivedLb: number | null;
  differenceFromExpectedSentLb: number | null;
  differenceFromExpectedSentPct: number | null;
  comparisonStatus: ShipmentFollowUpComparisonStatus;
}
